var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"hidden","name":"_token"},domProps:{"value":_vm.csrf}})}
var staticRenderFns = []

export { render, staticRenderFns }